import { tabManager } from '../../shared/tabManager';
import { NOTIFICATION_CONSUMED } from './types';

export const markNotificationAsConsumed = (notificationId) => () => {
    tabManager.broadcast(notificationConsumed(notificationId));
};

function notificationConsumed(notificationId) {
    return {
        type: NOTIFICATION_CONSUMED,
        payload: notificationId,
    };
}
